import React from 'react';
import PropTypes from 'prop-types';

import StaticMap from './StaticMap';
import Address from './Address';
import FooterNavigation from './FooterNavigation';

import './Footer.module.css';

Footer.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    street: PropTypes.string.isRequired,
    postcode: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    instagram: PropTypes.string.isRequired,
    facebook: PropTypes.string.isRequired,

    map_title: PropTypes.string.isRequired,
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
  }).isRequired,
};

function Footer({ data }) {
  return (
    <div styleName="Footer">
      <div className="wrapper" style={{ paddingBottom: 0 }}>
        <Address data={data} />
        <StaticMap data={data} />
      </div>
      <div className="wrapper" style={{ padding: 0 }}>
        <FooterNavigation data={data} />
      </div>
    </div>
  );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js